import React, { useEffect, useRef, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'antd';
// import { breadcrumbNameMap } from '@/routes/menus';
import './style.less';
import { getLocalStorage } from '@/hooks/useUserInfo';

export interface NormalBreadcrumbProps {
  // eslint-disable-next-line react/no-unused-prop-types
  children?: React.ReactNode;
}
type MenuItemType = {
  menuName: string;
  path: string;
  children?: MenuItemType[];
};

function loop(arr: MenuItemType[], json: Record<string, MenuItemType>) {
  arr?.forEach((item) => {
    const { path, menuName, children, ...rest } = item;
    json[path] = { ...rest, path, menuName };
    if (Array.isArray(children)) {
      loop(children as MenuItemType[], json);
    }
  });
}

export const useBreadcrumbNameMap = () => {
  const menuMapRef = useRef<Record<string, MenuItemType>>({});
  useEffect(() => {
    try {
      // @ts-ignore
      const menuList = JSON.parse(window.localStorage.getItem('$MenuRole$'));
      const json = {};
      loop(menuList, json);
      menuMapRef.current = { ...json };
    } catch (e) {}
  }, []);
  return { menuMapRef };
};

const NormalBreadcrumb: React.FC<NormalBreadcrumbProps> = () => {
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter((i) => i);
  // const { menuMapRef } = useBreadcrumbNameMap();

  const menuMap = getLocalStorage('$MenuMap$') || {};

  const items = useMemo(() => {
    const result: { key: string; title: React.ReactNode }[] = [
      { key: 'home', title: <Link to="/">首页</Link> },
    ];
    pathSnippets.forEach((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
      if (menuMap?.[url]?.menuName) {
        result.push({ key: url, title: <Link to={url}>{menuMap?.[url]?.menuName}</Link> });
      }
    });
    return result;
  }, [location.pathname, menuMap]);

  return (
    <div className="normal-breadcrumb-title">
      <Breadcrumb items={items} />
    </div>
  );
};

export default NormalBreadcrumb;
